import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { GET } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { EditFlashMessageRequest } from './editflashmessagesrequest';

export class EditFlashMessageAPI extends SixdeeCRBTAPI<EditFlashMessageRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return GET;
    }

    getAPIURL(): string
    { 
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/list-tones
        return "list-tones";
    }
}






// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/edit/editflashmessagesapi.tsx